import React from 'react';

export default function GeneralLedger() {
  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold mb-4">General Ledger</h1>
      <p className="text-gray-500">Halaman General Ledger</p>
    </div>
  );
}
